import { Controller,Post,Body, HttpException, HttpStatus, Query, Req, Get, Delete, Param, UseInterceptors, UploadedFiles } from '@nestjs/common';
import {AuthService} from './auth.service';
import {bGroupSearchDto, CreateUserDto,LoginUserDto, OtpDto,  SetPinDto, SignUpDto, UserIdDto, UserRoleDto, userSearchDto, VerifyOtpDto, } from '../user/dto/user.dto'
import {AllUserStatus, LoginStatus, OtpStatus, RegistrationStatus, searchResponseModel, UserStatus, UserStatusWiseResponseModel} from '../user/dto/registraton.dto';
import { ApiConsumes, ApiOperation, ApiProperty, ApiQuery, ApiTags } from '@nestjs/swagger';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { JwtAuthGuard } from './jwt-auth.guard';
import { FileFieldsInterceptor, FilesInterceptor } from '@nestjs/platform-express';
import { imageFileFilter } from '../shared/file-upload';
import { extname } from 'path';
import { diskStorage } from 'multer';

@ApiTags('Auth')
@Controller('auth')
export class AuthController {
  constructor(private readonly authService:AuthService) {}

  @Post('/register') 
  @ApiOperation({summary:'add user'})
  @UseInterceptors(	
    FileFieldsInterceptor([{
      name:'membershipPic', maxCount: 1,
    },{name:'otherPicImg', maxCount: 1},],
    {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/profilePic',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),	
  )
  @ApiConsumes('multipart/form-data') 
  public async register(@Query() queryParams,@UploadedFiles() files, @Body() createUserDto: CreateUserDto): Promise<RegistrationStatus> {    
    try {
     const response = [];
      const response1 = [];
      if(files.otherPicImg) {
        files.otherPicImg.forEach(file => {
          const fileReponse =  `profile/profilePic/${file.filename}`;
         response.push(fileReponse);
        })
      }
      if(files.membershipPic) {
        files.membershipPic.forEach(file => {
          const fileReponse =  `profile/profilePic/${file.filename}`;
         response1.push(fileReponse);
        })
      }      
      return await this.authService.register(queryParams,createUserDto,response,response1);
    } catch (error) {
      return errorHandler(RegistrationStatus,error);
    } 
  } 

  @Post('/signup')
  @ApiOperation({summary:'user sign up from mobile application'})
  @UseInterceptors(		
    FilesInterceptor('membershipPic', 1, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/profilePic',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
  )
  @ApiConsumes('multipart/form-data')
  public async signup(@Query() queryParams, @UploadedFiles() membershipPic,@Body() signupDto:SignUpDto):Promise<LoginStatus> {
    try {
      const response1 = [];
      if(membershipPic) {
        membershipPic.forEach(file => {
          const fileReponse = `profile/profilePic/${file.filename}`
          response1.push(fileReponse);
        })
      }      
      return await this.authService.signup(queryParams,signupDto,response1);
    } catch (error) {
      return errorHandler(LoginStatus,error);
    }
  }

  @Post('/resendOtp')
  @ApiOperation({summary:'resend otp to mobile'})
  public async resendOtp(@Query() queryParams, @Body() otpDto:OtpDto, ):Promise<UserStatus> {
    try {
      return await this.authService.resendOtp(queryParams,otpDto);
    } catch (error) {
      return errorHandler(UserStatus, error);
    }
  }

  @Post('/verifyOtp')
  @ApiOperation({summary:'verify otp'})
  public async verifyOtp(@Query() queryParams, @Body() verifyOtpDto:VerifyOtpDto):Promise<OtpStatus> {
    try {
      return await this.authService.verifyOtp(queryParams, verifyOtpDto);
    } catch (error) {
      return errorHandler(OtpStatus, error);
    }
  }  

  @Post('/setPin')
  @ApiOperation({summary:'user can set pin here'})
  public async setPin(@Query() queryParams, @Body() setPinDto:SetPinDto, @Req() request:Request): Promise<UserStatus> {
    try {
      return await this.authService.setPin(queryParams, setPinDto, request);
    } catch (error) {
      return errorHandler(UserStatus, error);
    }
  }

  @Post('/login')  
  @ApiOperation({summary:'user login'})
  public async login(@Query() queryParams, @Body() loginUserDto: LoginUserDto): Promise<LoginStatus> {
    try {
      return await this.authService.login(queryParams,loginUserDto); 
    } catch(error) {
      return errorHandler(LoginStatus, error);
    }
  }

  @Post('/forgotPassword')
  @ApiOperation({summary:'forgot password'})
  public async forgotPassword(@Query() queryParams, @Body() otpDto:OtpDto):Promise<LoginStatus> {
    try {
      return await this.authService.forgotPassword(queryParams,otpDto);
    } catch (error) {
      return errorHandler(LoginStatus,error);
    }
  }

  @Post('/deleteUser')
  @ApiOperation({summary:'user soft delete'})
  public async deleteUser(@Query() queryParams, @Body() userIdDto:UserIdDto, @Req() request:Request):Promise<LoginStatus> {
    try {
      return await this.authService.deleteUser(queryParams, userIdDto, request);
    } catch (error) {
      return errorHandler(LoginStatus, error);
    }
  }

  @Post('/changeUserRole')
  @ApiOperation({summary:'2 - mla, 3 - dist head, 4 - mandal head, 5 - village head, 6 - people'})
  public async changeUserRole(@Query() queryParams, @Body() userRoleDto:UserRoleDto, @Req() request:Request):Promise<LoginStatus> {
    try {
      return await this.authService.changeUserRole(queryParams, userRoleDto, request);
    }catch (error) {
      return errorHandler(LoginStatus, error);
    }
  }

  @Get('/getAllUsers') 
  @ApiQuery({name:'apiVersion'})
  @ApiQuery({name:'skip'}) 
  public async getAllUsers(@Query() queryParams): Promise<AllUserStatus> {
    try {
      return await this.authService.getAllUsers(queryParams);
    } catch (error) {
      return errorHandler(AllUserStatus,error);
    }      
  }   

  @Get('/getActiveUsersCount')  
  public async getActiveUsersCount(@Query() queryParams): Promise<UserStatusWiseResponseModel> {
    return await this.authService.getActiveUsersCount(queryParams);  
  } 
  
  @Post('/searchUser')
  @ApiQuery({name:'apiVersion'})
  public async getSearchUser(@Query() queryParams, @Body() userSearchDto:userSearchDto, @Req() request:Request): Promise<searchResponseModel> {
    try {
      return await this.authService.getSearchUser(queryParams,userSearchDto,request);
    } catch (error) {
      return errorHandler(searchResponseModel, error);
    }
  }

  @Get('/bloodDonorslist')
  @ApiQuery({name:'apiVersion'})
  @ApiQuery({name:'skip'})
  @ApiQuery({name:'BGroupId'})
  @ApiQuery({name:'villageId'})
  public async getDonorslist(@Query() queryParams, @Req() request:Request): Promise<searchResponseModel> {
    try {
      return await this.authService.getDonorslist(queryParams,request);
    } catch (error) {
      return errorHandler(searchResponseModel, error);
    }
  }

  @Get('/SetPintoBulk') 
  @ApiQuery({name:'apiVersion'})
  public async SetPintoBulk(@Query() queryParams): Promise<AllUserStatus> {
    try {
      return await this.authService.SetPintoBulk(queryParams);
    } catch (error) {
      return errorHandler(AllUserStatus,error);
    }      
  }   

}
